import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';

import { AuthContext } from '../../auth/AuthContext';
import { useContextInfo } from '../../context/ContextInfo';
import { UserContext } from '../../context/user/ContextUser';
import { useForm } from '../../hooks/useForm';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import moment from 'moment';
import { fetchConToken } from '../../api/fetch';
const initialState = {
    tipo: 'OTRO',
    operador: '',
    tarea: '',
    nota: '',
    puntos: 1,
};
const ModTarea = ({ show, onClose, callBk, item }) => {
    const { auth } = useContext(AuthContext);
    const [send, setSend] = useState(false);
    const [validated, setValidated] = useState(false);
    const { setResp } = useContextInfo();
    const [ayudantes, setAyudantes] = useState(null);
    const [encargado, setEncargado] = useState(null);

    const { usersState } = useContext(UserContext);
    const { agentes } = usersState;
    const [values, handleInputChange, reset, setFormValue] = useForm(initialState);
    useEffect(() => {
        laodParmas();
    }, [show, item]);

    const laodParmas = async () => {
        if (!show) {
            setAyudantes(null);
            setEncargado(null);
            setFormValue({ ...initialState });
        } else {
            if (item?.id_tarea) {
                const resp = await fetchConToken(`tareas/asignacion/${item?.id_tarea}`);
                if (resp.ok) {
                    const { data } = resp;
                    setAyudantes(data.ayudantes);
                    setEncargado(data.lider);
                    setFormValue({ ...values, ...item });
                }
            } else {
                setAyudantes(null);
                setEncargado(null);
                setFormValue({ ...initialState });
            }
        }
    };
    const onSubmit = async (e) => {
        e.preventDefault();
        if (send) return;
        const form = e.currentTarget;

        if (form.checkValidity() === false && encargado.value === '') {
            setValidated(true);
        } else {
            setSend(true);

            const resp = await fetchConToken(
                `tareas/new`,
                { ...values, operador: auth.uid, ayudantes, encargado },
                'POST'
            );
            setResp(resp);
            if (resp.ok) {
                setAyudantes(null);
                setEncargado(null);

                reset();

                onClose();
                callBk();
            }
        }
        setSend(false);
    };
    const closemOD = () => {
        setAyudantes(null);
        setEncargado(null);
        setFormValue({ ...initialState });
        onClose();
    };
    return (
        <Modal show={show} onHide={closemOD} size="xl">
            <Modal.Header onHide={closemOD} closeButton>
                <h4 className="modal-title">{!item?.id_tarea ? 'Nueva' : 'Editar'} tarea</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        <Row>
                                            <Col sm={12}>
                                                <Form.Group className="mb-3" controlId="validationCustom121">
                                                    <Form.Label>Tarea</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Activides a realizar"
                                                        as="textarea"
                                                        value={values.tarea}
                                                        name="tarea"
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col lg={4}>
                                                <Form.Group className="mb-3" controlId="validationCustom19">
                                                    <Form.Label>Lider de equipo</Form.Label>
                                                    <Select
                                                        className="react-select"
                                                        placeholder={'Lider'}
                                                        maxMenuHeight="550px"
                                                        value={encargado}
                                                        onChange={setEncargado}
                                                        options={agentes
                                                            .filter((ag) => ag.campo)
                                                            .map((ag) => ({
                                                                value: ag.id_agent,
                                                                label: ag.name,
                                                            }))}
                                                        classNamePrefix="react-select"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col lg={6}>
                                                <Form.Group className="mb-3" controlId="validationCustom19">
                                                    <Form.Label>Ayudantes</Form.Label>
                                                    <Select
                                                        className="react-select"
                                                        placeholder={'Ayudantes'}
                                                        maxMenuHeight="550px"
                                                        value={ayudantes}
                                                        isMulti
                                                        onChange={setAyudantes}
                                                        options={agentes
                                                            .filter((ag) => ag.campo)
                                                            .map((ag) => ({
                                                                value: ag.id_agent,
                                                                label: ag.name,
                                                            }))}
                                                        noOptionsMessage={() => 'Sin resultados'}
                                                        classNamePrefix="react-select"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col sm={2}>
                                                <Form.Group className="mb-3" controlId="validationCustom121">
                                                    <Form.Label>Puntos</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.puntos}
                                                        name="puntos"
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {send ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModTarea;
